module.exports = __webpack_public_path__ + "static/media/Selfie-X-01.a2379a47.png";